import { render, staticRenderFns } from "./MapIconRestoranManor.vue?vue&type=template&id=78a57a78&scoped=true&"
import script from "./MapIconRestoranManor.vue?vue&type=script&lang=js&"
export * from "./MapIconRestoranManor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a57a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a57a78')) {
      api.createRecord('78a57a78', component.options)
    } else {
      api.reload('78a57a78', component.options)
    }
    module.hot.accept("./MapIconRestoranManor.vue?vue&type=template&id=78a57a78&scoped=true&", function () {
      api.rerender('78a57a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconRestoranManor.vue"
export default component.exports